/**
 * Component to display a funding source icon (e.g. Visa) and source information.
 */
import React, { Component } from 'react';
import { Grid, Paper, Tooltip, Typography } from '@mui/material';
import ReportProblem from '@mui/icons-material/ReportProblem';
import AbEnvironment from '../auth/AbEnvironment';
import { yellow } from '@mui/material/colors'; 

const abEnvironment = new AbEnvironment();

class FundingSourceTile extends Component {

  render() {
    const yellowColor = yellow[600];

    let sNum = '';
    let sExp = null;
    let sName = '';

    if (this.props.psType === 0) {
      if (this.props.ccBrand === 'American Express') {
        sNum = 'Amex ****' + this.props.ccLast4; 
      } else {
        sNum = this.props.ccBrand + ' ****' + this.props.ccLast4; 
      }
      sExp = this.props.ccExpy.substring(0,2) + '/' + this.props.ccExpy.substring(2,4);
      sName = this.props.firstName + ' ' + this.props.lastName;
    } else if (this.props.psType === 1) {
      if (this.props.fiName != null) {
        sNum = this.props.fiName;
      } else {
        sNum = 'ACH';
      }

      // As of 12/12/19, putting Dwolla account nickname in account num
      if (this.props.achAccountNum != null) {  
        sName = this.props.achAccountNum;
      } else {
        sName = '****';
      }
    } else if (this.props.psType === 2) {
      if (this.props.paypalEmail != null) {
        sNum = this.props.paypalEmail;
      } 

    } else if (this.props.psType === 3) {
      if (this.props.extPsId != null) {
        sNum = '****' + this.props.extPsId.substring(this.props.extPsId.length - 6, this.props.extPsId.length);
      } 


    } else {
      sNum = '****';
    }

    let declineToolTip = "This funding source was declined the last time we attempted to charge it.  " +  abEnvironment.getDeclineReason(this.props.lastDeclineReason);
    if (this.props.lastDeclineChargeAmount) {
      let formattedDeclineAmount = Number(this.props.lastDeclineChargeAmount).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2});
      declineToolTip = declineToolTip + '  Amount of attempted charge was ' + formattedDeclineAmount;
    }

    if (this.props.drawmode === 'dashboard') {
      return (
        <Paper>
          <Grid container alignItems="center">
            <Grid item style={{width:'96px', height: '72px'}}>
              {this.props.psType === 0 && this.props.ccBrand === 'MasterCard' &&
              <img alt="MasterCard" height="48px" style={{float: 'left', marginTop: '12px', marginLeft: '20px'}} src={'/cards/mc-logo.png'} />}
              {this.props.psType === 0 && this.props.ccBrand === 'Visa' &&
              <img alt="Visa" height="36px" style={{float: 'left', marginTop: '18px', marginLeft: '20px'}} src={'/cards/visa-logo.png'} />}
              {this.props.psType === 0 && this.props.ccBrand === 'American Express' &&
              <img alt="AmericanExpress" height="39px" style={{float: 'left', marginTop: '17px', marginLeft: '18px'}} src={'/cards/amex-logo.png'} />}
              {this.props.psType === 0 && this.props.ccBrand === 'Discover' &&
              <img alt="Discover" height="36px" style={{float: 'left', marginTop: '18px', marginLeft: '20px'}} src={'/cards/discover-logo.png'} />}
              {this.props.psType === 1 &&
              <img alt="ACH" height="48px" style={{float: 'left', marginTop: '12px', marginLeft: '22px'}} src={'/ach.png'} />}
              {this.props.psType === 2 &&
              <img alt="PayPal" height="48px" style={{float: 'left', marginTop: '12px', marginLeft: '16px'}} src={'/cards/paypal.png'} />}
              {this.props.psType === 3 &&
              <img alt="PaymentRails" height="30px" style={{float: 'left', marginTop: '12px', marginLeft: '24px'}} src={'/cards/paymentrails.png'} />}
            </Grid>
            <Grid item style={{paddingRight: '8px'}}>
              <Typography variant="subtitle2" display="block" align="left">{sNum}</Typography>
                <Typography variant="caption" display="block" align="left" data-recording-sensitive>{sName}</Typography>
                {sExp != null &&
              <Typography variant="caption" display="block" align="left">Expires: {sExp}</Typography>}
            </Grid>
            { this.props.declineCount > 0 &&
            <Grid item style={{marginLeft: 16, marginRight: 16}}>
              <Tooltip title={declineToolTip}>
                <ReportProblem htmlColor={yellowColor}/>
              </Tooltip>
            </Grid>
            }
          </Grid>
        </Paper>
      );
    } else {
      return (
        <Grid container alignItems="center">
          <Grid item style={{width:'84px'}}>
            {this.props.psType === 0 && this.props.ccBrand === 'MasterCard' &&
            <img alt="MasterCard" height="48px" style={{float: 'right', marginRight: '17px'}} src={'/cards/mc-logo.png'} />}
            {this.props.psType === 0 && this.props.ccBrand === 'Visa' &&
            <img alt="Visa" height="36px" style={{float: 'right', marginRight: '12px'}} src={'/cards/visa-logo.png'} />}
            {this.props.psType === 0 && this.props.ccBrand === 'American Express' &&
            <img alt="AmericanExpress" height="39px" style={{float: 'right', marginRight: '16px'}} src={'/cards/amex-logo.png'} />}
            {this.props.psType === 0 && this.props.ccBrand === 'Discover' &&
            <img alt="Discover" height="36px" style={{float: 'right', marginRight: '16px'}} src={'/cards/discover-logo.png'} />}
            {this.props.psType === 1 &&
            <img alt="ACH" height="48px" style={{float: 'right', marginRight: '15px'}} src={'/ach.png'} />}
            {this.props.psType === 2 &&
            <img alt="PayPal" height="48px" style={{float: 'left', marginLeft: '16px'}} src={'/cards/paypal.png'} />}
            {this.props.psType === 3 &&
            <img alt="PaymentRails" height="30px" style={{float: 'left', marginTop: '12px', marginLeft: '24px'}} src={'/cards/paymentrails.png'} />}
          </Grid>
          <Grid item>
            <Typography variant="subtitle2" display="block" align="left">{sNum}</Typography>
            <Typography variant="caption" display="block" align="left" data-recording-sensitive>{sName}</Typography>
            {sExp != null &&
            <Typography variant="caption" display="block" align="left">Expires: {sExp}</Typography>}
          </Grid>
          { this.props.declineCount > 0 &&
          <Grid item style={{marginLeft: 16}}>
            <Tooltip title={declineToolTip}>
              <ReportProblem htmlColor={yellowColor}/>
            </Tooltip>
          </Grid>
          }

        </Grid>
      );
    }
  }
}

export default FundingSourceTile;